import React from 'react';
import { View } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import LHModalPop from '../../../components/LHModalPop';
import { RootState } from '../../../store';
import { hideErrorModal, removeErrorById } from '../../../store/slices/contactUsSlice';

const getApiTitle = (apiName?: string): string => {
  if (!apiName) return 'Error';

  // If apiName looks like a path (contains slashes), turn into human-readable title
  if (apiName.includes('/') || apiName.includes('-') || apiName.includes('_')) {
    // remove leading/trailing slashes
    const cleaned = apiName.replace(/^\/+|\/+$/g, '');
    // split path segments and replace hyphens/underscores with spaces
    const parts = cleaned.split('/').map((seg) => seg.replace(/[-_]+/g, ' ').trim());
    // Title-case each word in each segment
    const humanParts = parts.map((seg) =>
      seg
        .split(' ')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
    );
    return `${humanParts.join(' / ')} Failed`;
  }

  // Fallback: convert camelCase or PascalCase to words
  const words = apiName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
  return `${words} Failed`;
};

const ContactUsErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const centralized = useSelector((state: RootState) => (state as any).contactUs?.centralizedErrors || { activeError: null, isErrorModalVisible: false });
  const { activeError, isErrorModalVisible } = centralized;

  const handleClose = () => {
    if (activeError) {
      try { dispatch(removeErrorById(activeError.id)); } catch (e) { /* swallow */ }
    }
    try { dispatch(hideErrorModal()); } catch (e) { /* swallow */ }
  };

  if (!activeError) return null;

  return (
    <LHModalPop
      visible={isErrorModalVisible}
      onClose={handleClose}
      title={getApiTitle(activeError.apiName)}
      description={activeError.message}
      showFooter={true}
      primaryButtonText="OK"
      secondaryButtonText=""
      onPrimaryPress={handleClose}
      showCloseButton={true}
    />
  );
};

export default ContactUsErrorModal;
